<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style="color: white; text-align: center; margin-bottom: 10px">Future Plan</h2>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body text-justify">
            <p>
              1. Bangladesh University of Professionals (BUP) affiliated
              Graduate and Post-Graduate degree will be conducted in
              Proyash-Chattogram
              <br />
              <br />
              2. Bangladesh Open University (BOU) Learning Center will be run
              within a short time in Proyash-Chattogram
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
